import React from 'react';
import type { NextPage } from 'next';

import { domofonAction } from '@r1-frontend/api-domru/api-content/v1/domofon-action';
import { TResponseDto } from '@r1-frontend/api-domru/api-content/v1/domofon-action/dto/ResponseDto';
import { equipment } from '@r1-frontend/api-domru/full-buy/v1/equipment';
import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import Layout from '~/src/features/_layout';
import YandexLanding from '~/src/features/yandex-landing';
import { initialProps } from '~/src/helpers/basePageFunc';
import getRequester from '~/src/helpers/getRequester';
import { saveIntercomAction } from '~/src/store/actions/intercom';
import { selectCompanyName } from '~/src/store/selectors/city';

interface IProps {
    city: ICurrentCity,
    companyName: string,
    yandexStationData: IEquipment[],
}

const YandexStationLandingPage: NextPage<IProps> = ({ city, companyName, yandexStationData }) => {
    const { cityIn, callCenter } = city;

    return (
        <Layout
            title={`Яндекс Станция – купить умную колонку с Алисой в ${cityIn}`}
            description={`При покупке умной колонки Яндекс.Станция с голосовым помощником Алиса Вы получите бесплатную подписку
                Яндекс.Плюс от 3 до 6 месяцев. Экономьте вместе ${companyName}! Подробности по тел.: ${callCenter}`}
            withMenu={true}
            withChat={true}
            withFooter={true}
        >
            <YandexLanding
                city={city}
                yandexStationData={yandexStationData}
            />
        </Layout>
    );
};

YandexStationLandingPage.getInitialProps = async(options) => {
    await initialProps(options, { isNeedAuthData: true });
    const { req, store } = options;
    const state = store.getState();
    const { city: { currentCity: city, provider: { providerId } } } = state;

    const companyName = selectCompanyName(state);

    const doRequest = getRequester(req);

    const [equipmentResponse, domofonResponse] = await Promise.all([
        doRequest.fullBuy<IEquipment[]>(
            equipment({
                providerId,
                categories: [EShopCategory.YandexStation],
            }),
        ),
        doRequest.apiContent<TResponseDto>(domofonAction({ filter: { available: 1 } })),
    ]);

    const yandexStationData = equipmentResponse.isSuccess ? equipmentResponse.payload : [];
    if (domofonResponse.isSuccess && domofonResponse.payload.items.length > 0) {
        // берем первую доступную акцию для текущего города
        store.dispatch(saveIntercomAction(domofonResponse.payload.items[0]));
    }

    return ({ city, companyName, yandexStationData });
};

export default YandexStationLandingPage;
